import { Controller } from "@hotwired/stimulus"

// Handles file upload form interactions.
// Enables submit button when a file Dunbar files is selected.
// Shows the AI summary choice and context field when a file is selected.
// Turning the summary off shows the filing fields (category, date, title) and
// hides the Slack choice, since there's no summary to post.
export default class extends Controller {
  static targets = ["input", "submit", "contextField", "summary", "summaryNote", "summaryNoteText", "filingField", "filingInput", "date", "title", "slackField"]
  static values = { fileable: Array }

  connect() {
    this.prefilledDate = null
  }

  fileSelected() {
    const file = this.inputTarget.files[0]
    const extension = file ? this.extension(file.name) : ""
    const fileable = Boolean(file) && this.fileableValue.includes(extension)
    this.submitTarget.disabled = !fileable

    this.contextFieldTargets.forEach(el => el.classList.toggle("hidden", !file))

    const note = this.note(file, extension, fileable)
    this.summaryNoteTextTarget.textContent = note || ""
    this.summaryNoteTarget.classList.toggle("hidden", !note)
    if (file) this.prefill(file.name)
    this.summaryChanged()
  }

  summaryChanged() {
    const filing = !this.summaryTarget.checked && !this.submitTarget.disabled

    this.filingFieldTargets.forEach(el => el.classList.toggle("hidden", !filing))
    this.filingInputTargets.forEach(el => { el.required = filing })
    this.slackFieldTargets.forEach(el => el.classList.toggle("hidden", filing))
  }

  // A warning when the file can't be filed; nothing otherwise.
  note(file, extension, fileable) {
    if (!file || fileable) return null
    const kind = extension ? `${extension} files` : "files with no extension"
    return `Dunbar can't file ${kind}. Use ${this.fileableValue.join(", ")}.`
  }

  extension(filename) {
    const dot = filename.lastIndexOf(".")
    return dot <= 0 ? "" : filename.slice(dot).toLowerCase()
  }

  // The date and title the server would otherwise fall back to: the
  // filename's YYYY-MM-DD prefix, and the rest of the name. A date the
  // person typed is kept; one prefilled from the last file is replaced.
  prefill(filename) {
    const base = filename.replace(/\.[^.]*$/, "")
    const match = base.match(/^(\d{4}-\d{2}-\d{2})[\s-]*/)
    const typed = this.dateTarget.value && this.dateTarget.value !== this.prefilledDate

    if (!typed) {
      this.prefilledDate = match ? match[1] : null
      this.dateTarget.value = this.prefilledDate || ""
    }
    this.titleTarget.placeholder = (match ? base.slice(match[0].length) : base).trim() || base
  }
}
